export var EN_US = {

    // **** Common Strings
    'tdc_add': 'Add',
    'tdc_address': 'Address',
    'tdc_cancel': 'Cancel',
    'tdc_city': 'City',
    'tdc_edit': 'Edit',
    'tdc_firstName': 'First Name',
    'tdc_goBack': 'GO BACK',
    'tdc_lastName': 'Last Name',
    'tdc_no': 'No',
    'tdc_notSpecified': 'not specified',
    'tdc_save': 'Save',
    'tdc_seeMore': 'See More',
    'tdc_seeLess': 'See Less',
    'tdc_state': 'State',
    'tdc_streetAddress1': 'Street Address 1',
    'tdc_streetAddress2': 'Street Address 2',
    'tdc_yes': 'Yes',
    'tdc_zip': 'ZIP ',

    // **** General
    'profilePagePath': '#/personal',
    'businessPagePath': '#/business',
    'en': 'English',
    'es': 'Spanish',
    'tdc_sponsorDefault': 'Sponsor Pending',
    'tdc_firstNameErrMsg': 'Please enter the first name',
    'tdc_lastNameErrMsg': 'Please enter the last name',
    'tdc_enterValueErrMssg': 'Please enter the value for this field.',
    'tdc_serviceCallFailureMsg': 'Oops!!! Something went wrong ',
    // Password Rules
    'tdc_passwordDisclaimerMessage': 'Password must be at least 8 characters and meet three of the four requirements below:',
    'tdc_passwordRule1': 'Password contains a lower case letter',
    'tdc_passwordRule2': 'Password contains an upper case letter',
    'tdc_passwordRule3': 'Password contains a number',
    'tdc_passwordRule4': 'Password contains a special character',
    // Resend Email Verification
    'tdc_resendemailbutton': 'Resend Email',
    'tdc_resendemailMessageHeader': 'This email has not been verified yet.',
    'tdc_resendemailMessageBody': 'Please check your inbox and click the URL link to verify this account.',
    'tdc_resendemailpopupHeader': 'Verify your account',
    'tdc_resendemailpopupBeforeEmail': 'An email with a unique URL has been just sent to',
    'tdc_resendemailpopupAfterEmail': 'Please check your inbox and click the URL link to verify account.',
    'tdc_resendemailpopupBeforePhone': 'Don\'t recognize this email address? Contact Customer Service at ',
    'tdc_resendemailpopupPhone': '1-800-487-1000',
    'tdc_resendemailpopupAfterPhone': ' for further assistance.',
    'tdc_resendemailpopupResendButton': ' RESEND EMAIL',
    // email-phone directive
    'emailPhoneRequired': 'Your email address or phone number is required',
    'emailPhoneInvalid': 'Your email address or phone number is Invalid',
    'emailRequired': 'Your email address is required',
    'emailInvalid': 'Your email address is Invalid',
    'phoneRequired': 'Your phone number is required',
    'phoneInvalid': 'Your phone number is Invalid',
    // birthday-picker directive
    'minimalInfoBirthDateErrorMsg': 'Please enter a valid Date',

    // **** My Profile Header
    'tdc_headerTitle': 'Account Settings',
    'tdc_accountIDLabel': 'Account ID',
    'tdc_accntMgrLabel': 'Account Manager',
    'tdc_personalTabTitle': 'Personal',
    'tdc_businessTabTitle': 'Business',
    'tdc_uploadPhotoLabel': 'UPLOAD PHOTO',
    'tdc_removePhotoLabel': 'REMOVE PHOTO',
    'tdc_photoSharingText': 'By uploading a photo you agree to share it on your Storefront',
    'tdc_photoErrMssg': 'Your photos couldn\'t be uploaded. Photos should be less than 2MB and saved as PNG, JPG, GIF or TIFF files.',
    // "tdc_firstNameLabel": "First Name",
    // "tdc_lastNameLabel": "Last Name",
    'tdc_preferredNameLabel': 'Preferred',
    // "tdc_saveBtnLabel":"SAVE",
    // "tdc_cancelBtnLabel": "CANCEL",
    'tdc_personalTitle': 'Personal Profile',
    'tdc_businessTitle': 'Business Profile',
    // "Image Cropping"
    'tdc_saveSelectBtnTxt': 'SAVE SELECTION',
    'tdc_rotateRightBtnTxt': 'RIGHT',
    'tdc_rotateLeftBtnTxt': 'LEFT',

    // **** Contact Details
    'tdc_contactdetailstext': 'CONTACT DETAILS',
    'tdc_mobiletext': 'Mobile Phone',
    'tdc_emailtext': 'Email',
    // "mobileerrortext": "Please enter the Mobile Phone Number",  (Cannot find the reference)
    // "emailerrortext": "Please enter email",  (Cannot find the reference)
    'tdc_duplicateEmailErrorText': 'This email address is already present as a username',
    // "emailUsernameInfoText": "Email address in login preferences will also be changed. Only specify an email type username.",
    // "contactdetailssavetext": "SAVE",
    // "contactdetailscanceltext": "CANCEL",
    // "tdc_streetaddress1": "Street Address 1",
    // "tdc_streetaddress2": "Street Address 2",
    // "tdc_citytext": "City",
    // "tdc_addresstext": "Address",
    // "tdc_statetext": "State",
    // "tdc_ziptext": "ZIP ",
    // "savetext": "SAVE",
    // "canceltext": "CANCEL",
    // "edittext": "Edit",
    'tdc_accountHolderLabel': 'Account Holder',
    'tdc_sponsorLabel': 'SPONSOR',
    'tdc_businessNameLabel': 'Business Name',
    'tdc_streetaddress1error': 'Please enter Street Address 1',
    'tdc_autocompletestreetaddress1error': 'The address entered does not match the address found, please check your address for correctness',
    'tdc_cityerror': 'Please enter city',
    'tdc_stateerror': 'Please enter state',
    'tdc_ziperror': 'Please enter zip',
    'tdc_zipLengthError': 'Please enter only 5 digits for zip code',
    'tdc_blockedPostalCodeError': 'Sorry, it is not possible to sign up using the entered postal code.',

    'convertDistributorPagePath': '/content/mecommerce/americas/US/en/signup/signup.html#/distributorsignup-minimal',
    'tdc_becomeDistributorLabel': 'Become a distributor',
    'tdc_uncoverLabel': 'Simply share our amazing products with your network and earn some cash with the opportunity to...',
    'tdc_step1': 'Develop your own team and enjoy extra bonuses for your leadership.',
    'tdc_step2': 'Take advantage of advanced tools for social sharing.',
    // "seeMore": "See More",
    // "seeLess": "See Less",

    // **** Personal Details
    'tdc_personaldetailstext': 'PERSONAL DETAILS',
    // "personalIDtext": "PERSONAL ID",   (*** it seems that this is never used)
    'tdc_ssntext': 'SSN',
    'tdc_sintext': 'SIN',
    'tdc_gendertext': 'Gender',
    'tdc_birthdatetext': 'Date of Birth',
    // "personalsavetext": "SAVE",
    // "personaledittext": "Edit",
    // "personalcanceltext": "CANCEL",
    'tdc_gender1': 'MALE',
    'tdc_gender2': 'FEMALE',
    'tdc_gender3': 'OTHER',
    // "personalDetailsLinkLabel": "personal details",  (*** it seems that this is never used)

    // **** Login Preferences
    'tdc_loginPrefsText': 'LOGIN PREFERENCES',
    'tdc_username': 'Username',
    'tdc_usernameErrorMsg': 'This email address is already present as a username.',
    'tdc_password': 'Password',
    // "confirmPassword": "Confirm Password",  (*** it seems that this is never used)
    // "confirmPasswordErrMsg": "Confirm Password",  (*** it seems that this is never used)
    'tdc_createPasswordTitle': 'Create Password',
    'tdc_confirmPasswordTitle': 'Confirm Password',
    'tdc_emptyPasswordError': 'Your password is required',
    'tdc_invalidPasswordError': 'Your password doesn\'t meet our requirements',
    'tdc_confirmPasswordError': 'Your confirm password is required',
    'tdc_passwordDoNotMatchError': 'The passwords you entered do not match.',
    'tdc_fixToContinueTitle': 'Please fix to continue',
    'tdc_clickToHidePasswordTitle': 'Click to hide Password',
    'tdc_clickToShowPasswordTitle': 'Click to show Password',
    // "loginFacebookLabel": "Login with Facebook",  (*** itseems that this is never used)
    // "prefsCancelLabel": "CANCEL",
    // "prefsSaveLabel": "SAVE",
    // "prefsEditBtnLabel": "Edit",

    // **** Billing Information  (commented out as we don't use it)
    // "tdc_billingInformationtext": "BILLING INFORMATION",
    // "tdc_primaryLabel": "Primary",
    // "tdc_expiredLabel": "Expired",
    // "tdc_endingInText": "Ending in ",
    // "tdc_expText": ", Exp ",
    // "tdc_billingMethodLabel": "Billing Method",
    // "tdc_nameOnCardLabel": "Name on Card",
    // "tdc_cardNumber": "Card Number",
    // "tdc_cardExpiration": "Card Expiration",
    // "tdc_billingAddress": "Billing Address",
    // // "billingfirstNameLabel": "First Name",
    // // "billinglastNameLabel": "Last Name",
    // // "billingStreetaddress1": "Street Address 1",
    // // "billingStreetaddress2": "Street Address 2",
    // // "billingcitytext": "City",
    // // "billingstatetext": "State",
    // // "billingziptext": "ZIP ",
    // "tdc_preferedCardLabel": "Preferred Card",
    // // "billingGoBackLabel": "GO BACK",
    // // "billingSaveLabel": "SAVE",
    // // "billingAddLabel": "Add",
    // "tdc_cardError": "Please enter valid value for this field.",
    // "tdc_setPrimaryErrMsg": "Please select a card which has not expired",

    // **** "Shipping Preferences" (commented out as we don't use it)
    // "tdc_shippingPreferencestext": "SHIPPING PREFERENCES",
    // // "shippingfirstNameLabel": "First Name",
    // // "shippinglastNameLabel": "Last Name",
    // // "shippingStreetaddress1": "Street Address 1",
    // // "shippingStreetaddress2": "Street Address 2",
    // // "shippingcitytext": "City",
    // // "shippingstatetext": "State",
    // // "shippingziptext": "ZIP ",
    // "tdc_preferredAddressLabel": "Preferred Address",
    // // "shippingGoBackLabel": "GO BACK",
    // // "shippingSaveLabel": "SAVE",
    // // "shippingAddLabel": "Add",

    // **** Communication Preferences
    'tdc_communicationPreferencestext': 'COMMUNICATION PREFERENCES',
    'tdc_contactPreferences': 'Contact Preference',
    'tdc_contactPreferencesText': 'If you would like to receive offers for special products or services, please opt-in and select the options you would like to receive.',
    'tdc_languagePreferences': 'Language Preference',
    'tdc_marketingEmailsLabel': 'Receive Marketing Emails',
    'tdc_emailCommunicationsLabel': 'Email Communications',
    'tdc_doNotContactText': 'Do Not Contact. By selecting this option you will be placed on Do Not Contact list, you will not receive any Newsletter, Special    Offering or Marketing emails from Nu Skin.',
    // "commPrefsCancelLabel": "CANCEL",
    // "commPrefsSaveLabel": "SAVE",
    // "commPrefsEditBtnLabel": "Edit",
    'tdc_commemailtext': 'Email',
    'tdc_commtextlabel': 'Text',
    'tdc_commmaillabel': 'Mail',

    // **** family  (Comment it out because we will NOT have it in the near future)
    // "enableFamilySection": "true", // it should go to configuration
    // "sectionTitle": "Family Members",
    // "friendsMessageOne": "Want to share your personal shopping account with friends and family? Send them an invitation to join your account.",
    // "friendsMessageTwo": "Friends and family on your shared account will use your billing details by default, so choose wisely! As the account holder, you'll retain administrative privileges.",
    // "removeMember": "To remove an associate from your account, call Customer Service.",
    // "friendsSeeMore": "See More",
    // "friendsSeeLess": "See Less",
    // "firstNameFriends": "First Name",
    // "lastNameFriends": "Last Name",
    // "firstNameErrFriends": "Please enter First Name",
    // "lastNameErrFriends": "Please enter Last Name",
    // "contactPreferencesFamily": "Contact Preferences",
    // "phoneOptionFamily": "PHONE",
    // "emailOptionFamily": "EMAIL",
    // "emailFamily": "Email",
    // "emailErrFamily": "Please enter Email Address",
    // "phoneFamily": "Phone",
    // "phonePlaceholderFamily": "Enter your Phone Number",
    // "phoneErrFamily": "Please enter Phone Number",
    // "addLabel": "Add",
    // "noFamily": "You don't have any family member assigned.",
    // "loadMore": "Load More",
    // "save": "SAVE",
    // "cancel": "CANCEL",
    // "edit": "Edit",
    // "buttonLabel": "FAMILY ACCOUNTS",
    // "emailtemplatepath": "/content",

    // **** Privacy Preferences
    'tdc_privacyPreferencestext': 'PRIVACY PREFERENCES',
    // "enableEveryOneOption": "true", // it should go to config
    'tdc_everyOneOptionText': 'Show my contact information to everyone (phone, address, email)',
    // "enableUplineOption": "true", // it should go to config
    'tdc_uplineOptionText': 'Show my contact information up to my first upline Blue Diamond',
    // "enableFamilyOption": "true", // it should go to config
    'tdc_familyOptionText': 'Show personal information family members',
    // "enableSponsorOption": "true", // it should go to config
    'tdc_sponsorSearchText': 'Allow me to be visible in sponsered search',
    // "enableSpannerOption": "true", // it should go to config
    // "spannerLocatorText": "Allow me to be visible in scanner locator",   // Comment it out because we do NOT use it
    // "privacySave": "SAVE",
    // "privacyCancel": "CANCEL",
    // "privacyEdit": "Edit",


    // Button Labels (move to the General)
    // "saveSelectBtnTxt": "SAVE SELECTION",
    // "cancelBtnTxt": "CANCEL",
    // "rotateRightBtnTxt": "Right",
    // "rotateLeftBtnTxt": "Left",

    // Profile Sponsor Info
    // "sponsorDefault": "Sponsor Pending",  // Move to General


    //* ***************************
    //  ****** Business *****
    //* ***************************

    // "tdc_notSpecifiedLabel": "not specified",

    // **** Account Details
    'tdc_accdltheader': 'ACCOUNT DETAILS',
    'accdltdistid': 'Distributor ID',
    'tdc_accdltacctype': 'Account',
    'tdc_accdltbussname': 'Business Name',
    'tdc_accdlttaxid': 'Tax ID',
    'tdc_hasTaxIdQuestion': 'Do you have a SIRET NUMBER',
    'tdc_confirmTaxIdPossession': 'True',
    'tdc_denyTaxIdPossession': 'False',
    'tdc_taxIdSubmissionWarning': 'Nu Skin requires the submission of a SIRET Number within 30 days of registration.',
    'tdc_agreeToObtainTaxId': 'YES I agree to submit a SIRET Number within 30 days.',
    'tdc_emailToObtainTaxID': 'Email me instructions on how to get a SIRET Number. (optional)',
    'tdc_accdetailsbussdistributorLabel': 'Change to Business Distributor',
    'tdc_accdetailsdescLine1': 'To uncover greater opportunities with Nu Skin.',
    // "tdc_accdetailsSeeMoreLabel": "See More",
    // "tdc_accdetailsSeeLessLabel": "See Less",
    'tdc_accdetailsdescLine2': 'Grow your business by adding two or more associates to expand your support team.',
    'tdc_accdetailsdescLine3': 'Further your reach and exposure by lorem ipsum dolor sit met.',
    'tdc_accdetailsbussDistributorSetupLabel': 'BUSINESS DISTRIBUTOR SETUP',
    'tdc_accdltbussnameError': 'Business name should be entered.',
    'tdc_accdetailsbussTaxIdError': 'Please enter Tax ID',
    'tdc_accdetailsbussDuplicateTaxId': 'Tax ID already Exists',
    'tdc_accdetailsbussDuplicateTaxIdActive': 'We\'re sorry, it looks like the Tax ID you entered is already in our system, please check your entry and try again (Active)',
    'tdc_accdetailsbussDuplicateTaxIdInActive': 'We\'re sorry, it looks like the Tax ID you entered is already in our system, please check your entry and try again (Inactive)',
    'tdc_accdetailsAcceptTermsButton': 'Next: Agree to the Terms',
    // "tdc_accdetailsCancelTermsButton": "CANCEL",
    'tdc_accdetailValidTaxIdError': 'Please enter a valid tax ID',
    'tdc_GSTRegisteredNumber': 'GST Registered Number (Optional)',
    'tdc_bankName': 'Bank Name',
    'tdc_primaryBusinessTaxId': 'Business Tax ID Name',
    'tdc_primaryBusinessTaxIdErrorMessage': 'Please enter a valid Tax ID',
    'tdc_primaryBusinessTaxIdRequiredErrorMessage': 'Please enter a Tax ID',
    'tdc_secondaryBusinessTaxId': 'Business Tax ID Name',
    'tdc_secondaryBusinessTaxIdErrorMessage': 'Please enter a valid Tax ID',
    'tdc_secondaryBusinessTaxIdRequiredErrorMessage': 'Please enter a Tax ID',
    'tdc_whatIsPrimaryBusinessTaxIdLink': '../../../../src/assets/pdf/ABN_GST_RCTI_FAQs.pdf',
    'tdc_whatIsPrimaryBusinessTaxId': 'What is an ABN?',
    'tdc_whatIsSecondaryBusinessTaxIdLink': '../../../../src/assets/pdf/ABN_GST_RCTI_FAQs.pdf',
    'tdc_whatIsSecondaryBusinessTaxId': 'What is an ABN?',
    'tdc_accDetailsWhatIsTaxIdLink': '../../../../src/assets/pdf/ABN_GST_RCTI_FAQs.pdf',
    'tdc_accDetailsWhatIsTaxIdMessage': 'What is an ABN?',
    // Contact Details (Duplicates in the Personal Tab)
    // "tdc_contactdetailstext": "CONTACT DETAILS",
    // "tdc_contactmobiletext": "Mobile Phone",
    // "tdc_contactemailtext": "Email",
    // "contactmobileerrortext": "Please enter the Mobile Phone Number",
    // "contactemailerrortext": "Please enter email",
    // "tdc_contactsavetext": "SAVE",
    // "tdc_contactcanceltext": "CANCEL",
    // "tdc_contactedittext": "Edit",

    // **** Banking Info
    'tdc_bankinfoheader': 'DIRECT DEPOSIT',
    'tdc_bankinfonameonacc': 'Name on Account',
    'tdc_bankinNameError': 'Please enter the account name',
    'tdc_bankinfoacctype': 'Account Type',
    'tdc_bankinforoutingno': 'Routing Number',
    'tdc_bankinforoutingnoerrormsg': 'Please enter 9 digit long valid routing number',
    'tdc_bankinfoaccno': 'Account Number',
    'tdc_bankinfoaccerrormsg': 'Please enter valid account number',
    // "tdc_bankinfosavebut": "SAVE",
    // "tdc_bankinfocancelbut": "CANCEL",
    'tdc_savingsOption': 'Savings',
    'tdc_checkingsOption': 'Checking',
    'tdc_agreeLabel': 'I agree to the',
    'tdc_directDepositLabel': 'Direct Deposit Policy',
    'tdc_directDepositPolicyPopUp': 'I authorize Nu Skin United States, Inc. (\'Nu Skin\') to deposit the payment of any commissions/bonuses to my account at the financial institution named above. I acknowledge and agree that it is my responsibility to make certain that the commissions/bonuses have been deposited in my account each month before writing any checks against the balance in said account. This authorization shall remain in full force and effect until (i) Nu Skin has received written notice from you of your withdrawal from the direct deposit program and (ii) Nu Skin has reasonable opportunity to make such a change pursuant to your notice. I understand that this authorization replaces any previous authorization and shall remain in effect until Nu Skin receives written notice of my withdrawal from the direct deposit program. It is imperative that you notify Nu Skin immediately prior to changing the above account or if your financial institution changes your routing number or account number. Failure to notify Nu Skin of account number changes may delay your receipt of commissions/bonuses. If you change your financial institution and/or account number you must fill out a new Direct Deposit Authorization Form and send it to Nu Skin before you close your existing account. Nu Skin shall not be liable to your for failing to access your account or provide direct deposits to your account in a timely manner unless such failure or loss is a direct result of Nu Skin\'s gross negligence or intentional misconduct. NU SKIN SHALL NOT BE LIABLE TO YOUR FOR PUNITIVE, SPECIAL, CONSEQUENTIAL, INCIDENTAL OR INDIRECT DAMAGES, WHETHER OR NOT ANY SUCH CLAIM FOR SUCH DAMAGES IS BASED ON TORT OR CONTRACT OR NU SKIN KNEW OR SHOULD HAVE KNOWN THE LIKELIHOOD OF SUCH DAMAGES IN ANY CIRCUMSTANCES, EVEN IF NU SKIN HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. Please note -- $1 processing fee for each weekly electronic deposit Monthly deposit on the 20th has no fee assigned. Pleae note -- $2 printed check fee. Debited from commission check.',
    'tdc_directDepositLabelErrMsg': 'Direct Deposit Policy should be accepted before continuing.',
    'tdc_accountValidationError': 'Name on the bank account must match either the business entity name or the primary associate\'s name',
    // "tdc_bankinInfoEdit": "Edit",
    'tdc_distributoreligibleerror': 'Oops, we can\'t validate your information, please check the information you entered and try again',
    'tdc_bankinfoserviceerr': 'Oops, we can\'t save your direct deposit info right now. Give us a little bit to fix it. You can always check back and update your bank details in your account settings.',
    'tdc_routingnumbererr': 'Please Enter a valid routing number.',
    'tdc_accounttypeselecterror': 'Please select Account type',
    'tdc_bankName': 'Bank Name',
    'tdc_bankNameValidationErrorMsg': 'Please Select Bank Name',
    'tdc_branchNumberValidationErrorMsg': 'Please enter a valid 5 digit Transit Number',
    'tdc_branchNumberLabel': 'Transit (Branch) Number',
    'tdc_accountNameSuggestion': 'As it appears on your account, first name last name',
    'tdc_bankInfoLocation': 'Where do I find this?',
    'tdc_bankCheckLinkTitle': 'Where do I find this?',
    'tdc_bankCheckTitle': 'Check Example',
    'bankCheckCloseImage': 'https://dev.mynuskin.com/etc/clientlibs/mecommerce/core/main/css/src/assets/images/css/cross-small.png',
    'bankCheckImage': 'https://test.mynuskin.com/content/dam/mecommerce/general/us-bank-info.png',
    'tdc_bankAccountDetails': 'Bank account details for Nu Skin to deposit into your account. ',
    'tdc_helplineMessage': 'For changes, please call distributor support at 1-800-487-1000, option 6.',
    'whatIsAbnLink': '../../../../src/assets/pdf/ABN_GST_RCTI_FAQs.pdf',

    // **** Address Info (Duplicates in Personal Tab)
    // "tdc_streetaddress1": "Street Address 1",
    // "tdc_citytext": "City",
    // "tdc_addresstext": "Address",
    // "tdc_statetext": "State",
    // "tdc_ziptext": "ZIP",
    // "tdc_addrsavetext": "SAVE",
    // "tdc_addrcanceltext": "CANCEL",
    // "tdc_streetaddress2": "Street Address 2",
    // "tdc_streetaddress1error": "Please enter Street Address 1",
    // "tdc_autocompletestreetaddress1error": "The address entered does not match the address found, please check your address for correctness",
    // "tdc_cityerror": "Please enter city",
    // "tdc_stateerror": "Please enter state",
    // "tdc_ziperror": "Please enter ZIP code",
    // "tdc_zipcodeValidErr": "Please enter valid ZIP code", (** changed to use zipLengthErr)
    // "sameAddressCheckbox": "Same as Home Address",  (** removed for now)
    // "tdc_addressedittext": "Edit",

    // **** Business Associate
    'tdc_bussAssociateLabel': 'Business Associate',
    'tdc_accPendingLabel': 'Account Pending',
    'tdc_accVerifiedLabel': 'Account Verified',
    'emailtext': 'Email',
    'mobileerrortext': 'Please enter the Mobile Phone Number',
    'emailerrortext': 'Please enter email',
    // "savetext": "SAVE",
    // "canceltext": "CANCEL",
    // "associateedittext": "Edit",
    // "tdc_associateaddtext": "Add",
    'tdc_noassociateLabel': 'You don\'t have any associates assigned',
    'tdc_loadmoreLabel': 'Load More',
    // "tdc_associatesavetext": "Save",
    // "tdc_associatecanceltext": "Cancel",
    'tdc_individualdistributorLabel': 'As an individual distributor, you can only add one associate.',
    'emailtemplatepath': '/content/mecommerce/americas/US/en/email-templates/inviteassociatemail',
    'resendemailtemplatepath': '/content/mecommerce/americas/US/en/email-templates/resendassociateinvite',
    'tdc_usernameErrorMsgBusiness': 'Email address is already in use',
    'tdc_sentLabel': 'Sent',
    'tdc_resendInviteLabel': 'Resend Invite',

    // Communication Pref (Move to the Personal Tab)
    // "tdc_commpreferenceLabel":  "Communication Preference",
    // "tdc_contactprefLabel": "Contact Preference",
    // "tdc_commemailtext": "Email",
    // "tdc_commtextlabel": "Text",
    // "tdc_commmaillabel": "Mail",
    // "tdc_commLangPref": "Language Preference",
    // "canceltext": "CANCEL",
    // "tdc_commedittext": "Edit",
    // "tdc_doNotContLabel": "Do Not Contact. By selecting this option you will be placed on Do Not Contact list, you will not receive any Newsletter, Special Offering or Marketing emails from Nu Skin.",
    // "tdc_marketmailLabel": "Receive Marketing Emails",
    // "tdc_commsavetext": "Save",
    // "tdc_commcanceltext": "Cancel",
    // "tdc_yesLabel": "Yes",
    // "tdc_noLabel": "No",
    // "tdc_emailcommLabel": "Email Communications",

    // Distributor Modal (For the Distributor to Business Conversion)
    'tdc_first_title': 'Distributor agreement and policies and procedures',
    'tdc_first_agree': 'I have read, understand and agree to the Distributor Agreement, including the',
    'tdc_second_agree': 'I have reviewed and understand the',
    'tdc_limitationliabilitylabel': 'limitation of liability',
    'tdc_arbitrationlabel': 'arbitration',
    'tdc_indemnificationlabel': 'indemnification',
    'tdc_provisionslabel': 'provisions therein.',
    'tdc_distributorCompensationLabel': 'Distributor Compensation Summary',
    'tdc_distributorCompensationPopupHeading': 'Distributor Compensation Summary',
    'distributorCompensationPath': '/content/dam/mecommerce/terms-and-conditions',
    'tdc_productpolicyLabel': 'Product Return Policy.',
    'tdc_productPolicyPopUpHeading': 'Product Return Policy',
    'productPolicyPath': '/content/dam/mecommerce/terms-and-conditions',
    'tdc_popUpBackButtonLabel': 'BACK',
    // "tdc_popUpGoBackButtonLabel": "GO BACK",
    'tdc_proceedlabel': 'Please accept the terms and conditions before proceeding.',
    'tdc_needtoagreetext': 'You\'ll need to agree to the Distributor Agreement in order to sell Nu Skin Products and earn commissions.',
    'tdc_downloadButton': 'Download a Copy',
    'distModalTitle': 'Distributor Handbook',
    'distAlertMsg': 'Things to Keep in Mind as a Distributor',
    'tdc_distTNCMsg': 'Before you may continue with your application, please review the terms and conditions of the Distributor Agreement and Policies and Procedures (&quot;Policies&quot;) located below. The Policies describe your rights and obligations as an independent Nu Skin distributor.',
    'tdc_distAgreement': 'Distributor Agreement',
    'distDefinitions': 'Definitions',
    'distDefnTerms': '/content/dam/mecommerce/terms-and-conditions',
    'distPolicyReview': 'Once you have reviewed the Policies, and if you agree to abide by them, please click the &quot;I agree&quot; box located below and continue with your application to become an independent distributor. PLEASE NOTE THAT BY CLICKING &quot;I AGREE&quot; YOU INDICATE THAT YOU HAVE READ AND UNDERSTAND THE POLICIES, AND AGREE TO BE BOUND BY THEM.',
    'distAccept': 'ACCEPT & CONTINUE',
    'tdc_distDecline': 'Decline',
    'distPolicyAccpt': 'Once you have reviewed the Policies, and if you agree to abide by them, please click the &quot;I agree&quot; box located below and continue with your application to become an independent distributor. PLEASE NOTE THAT BY CLICKING &quot;I AGREE&quot; YOU INDICATE THAT YOU HAVE READ AND UNDERSTAND THE POLICIES, AND AGREE TO BE BOUND BY THEM.',
    'tdc_areyousure': 'Are you sure you want to skip accepting the distributor agreement, policies, and procedures?',
    'tdc_declinetext': 'If you don\'t complete this step, you wont be able to sell Nu Skin products or earn commissions.',
    'declinepath': '#/business',
    'tdc_closepopuplabel': 'NEVERMIND',
    'tdc_remindmelater': 'REMIND ME LATER',

    // Distributor Confirmation Modal
    'tdc_distConfirm': 'You are now a Business Distributor!',
    'tdc_distUpdateInfo': 'Be sure to update any information that might have changed, such as:',
    'tdc_distContactInfo': 'Contact and business information',
    'tdc_distAddMoreAss': 'Add more associates ',
    'tdc_distBankingInfo': 'Banking information',
    'tdc_distOk': 'Okay',

    // Associate Modal
    'tdc_addBusinessAssociate': 'Add Business Associates',
    'tdc_businessAssociateInviteLabel': 'Want to run your business with a trusted associate? Send them an invitation to join your account.',
    'tdc_businessAssociateDescLabel': 'Associates share your business account but you remain primary account holder with administrative privileges.All distributors are eligible to add their spouse to their account to help them manage their business as a team. If your spouse is not interested in managing the business but still wants to purchase a custom product, consider adding a family member account. Business Accounts are eligible to add partners to their account. All Business partners are required to be a part of the legal entity associated with your Nu Skin account.',
    // "tdc_businessAssociateSeeMoreLabel": "See More",
    // "tdc_seeMoreText": ["All distributors are eligible to add their spouse to their account to help them manage their business as a team. If your spouse is not interested in managing the business but still wants to purchase a custom product, consider adding a family member account.", "Business Accounts are eligible to add partners to their account. All Business partners are required to be a part of the legal entity associated with your Nu Skin account."],
    'iItems': [
        {'tdc_seeMoreText': 'All distributors are eligible to add their spouse to their account to help them manage their business as a team. If your spouse is not interested in managing the business but still wants to purchase a custom product, consider adding a family member account.'},
        {'tdc_seeMoreText': 'Business Accounts are eligible to add partners to their account. All Business partners are required to be a part of the legal entity associated with your Nu Skin account.'}
    ],
    // "tdc_businessAssociateSeeLess": "See Less",
    // "tdc_businessAssociateFirstNameLabel": "First name",
    'tdc_businessAssociateFirstNameErrorLabel': 'Enter First name',
    // "tdc_businessAssociateLastNameLabel": "Last name",
    'tdc_businessAssociateLastNameErrorLabel': 'Enter last name',
    'tdc_businessAssociateMobilePhoneLabel': 'Mobile Phone',
    'tdc_businessAssociateMobilePhoneErrorLabel': 'Enter a Mobile Phone number',
    'tdc_businessAssociateContactPrefLabel': 'Contact Preference',
    'tdc_businessAssociateContactPrefEmailLabel': 'Email',
    'tdc_businessAssociateContactPrefMobileLabel': 'Mobile Phone',
    'tdc_businessAssociateSendInviteLabel': 'Send Invite',
    // "tdc_businessAssociateCancelLabel": "Cancel",

    // "Button Labels-Business"
    // "tdc_saveSelectBtnTxt": "SAVE SELECTION",
    // // "tdc_cancelBtnTxt": "CANCEL",
    // "tdc_rotateRightBtnTxt": "RIGHT",
    // "tdc_rotateLeftBtnTxt": "LEFT",

};



//////////////////
// WEBPACK FOOTER
// ./data/strings.en_us.js
// module id = 362
// module chunks = 0